import { Link } from "react-router-dom";
import SectionHeading from "@/components/base/SectionHeading";
import LiveCard from "@/components/base/LiveCard";
import { hotFeed } from "@/mocks/content";
import { liveSessions } from "@/mocks/lives";
import { padIndex } from "@/utils/format";

export default function HotFeedSection() {
  const featured = liveSessions.filter((item) => item.featured).slice(0, 4);

  return (
    <section className="w-full bg-background-50 px-4 py-14 md:px-6 md:py-20">
      <SectionHeading
        eyebrow="Trending"
        title="热点爆料与精选现场"
        desc="按当前观看人数与信号稳定度排序，帮你在第一时间找到值得停留的那一路画面。"
        linkTo="/live"
        linkLabel="浏览全部现场"
      />

      <div className="mt-8 grid grid-cols-1 gap-6 lg:grid-cols-12 md:mt-10 lg:gap-8">
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:col-span-8 md:gap-5">
          {featured.map((item) => (
            <LiveCard key={item.id} item={item} />
          ))}
        </div>

        <aside className="lg:col-span-4" aria-label="热点爆料榜单">
          <div className="flex h-full flex-col rounded-lg border border-background-200/70 bg-background-100 p-5">
            <div className="flex items-center justify-between gap-3">
              <h3 className="flex items-center gap-2 font-heading text-base font-bold text-foreground-950">
                <i className="ri-fire-line text-accent-500" aria-hidden="true" />
                实时热度榜
              </h3>
              <span className="font-label text-[11px] text-foreground-500">每 5 分钟更新</span>
            </div>

            <ol className="mt-4 flex flex-1 flex-col divide-y divide-background-200/70">
              {hotFeed.map((item, index) => (
                <li key={item.id}>
                  <Link
                    to={`/live/${item.liveId}`}
                    className="group flex cursor-pointer items-start gap-3 py-3"
                  >
                    <span
                      className={`mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-md font-label text-[11px] ${
                        index < 3
                          ? "bg-accent-500 text-background-50"
                          : "bg-background-200/80 text-foreground-600"
                      }`}
                    >
                      {padIndex(index + 1)}
                    </span>
                    <span className="min-w-0 flex-1">
                      <span className="block text-[13px] font-medium leading-snug text-foreground-900 transition-colors group-hover:text-primary-500">
                        {item.title}
                      </span>
                      <span className="mt-1 flex flex-wrap items-center gap-x-3 gap-y-1 text-[11px] text-foreground-500">
                        <span className="text-secondary-700">{item.category}</span>
                        <span className="inline-flex items-center gap-1 whitespace-nowrap">
                          <i className="ri-eye-line" aria-hidden="true" />
                          {item.heat}
                        </span>
                        <span className="whitespace-nowrap">{item.time}</span>
                      </span>
                    </span>
                  </Link>
                </li>
              ))}
            </ol>

            <Link
              to="/live"
              className="mt-3 inline-flex cursor-pointer items-center justify-center gap-1.5 whitespace-nowrap rounded-md border border-background-300/60 px-4 py-2.5 text-[13px] text-foreground-800 transition-colors hover:border-primary-500/60 hover:text-primary-500"
            >
              查看完整榜单
              <i className="ri-arrow-right-line" aria-hidden="true" />
            </Link>
          </div>
        </aside>
      </div>
    </section>
  );
}